import { Authorizer, OlympusAuthorizationProvider } from '@owner/auth'
import type { OlympusUser, OlympusBrandSession } from '@owner/auth'

let authorizerInstance: Authorizer | null = null

/**
 * Get the Authorizer singleton instance
 * Components use this to access authorizer.can(), authorizer.hasRole(), etc. directly
 */
export const useAuthorizer = (): Authorizer => {
  if (!authorizerInstance) {
    throw new Error(
      'Authorizer not initialized. Call initializeAuthorizer() after login.'
    )
  }
  return authorizerInstance
}

export const initializeAuthorizer = async (
  user: OlympusUser,
  brandSession: OlympusBrandSession
): Promise<void> => {
  const provider = new OlympusAuthorizationProvider(user, brandSession)
  authorizerInstance = new Authorizer({
    // No background refresh needed - Hermes re-initializes on login/brand switch
    autoRefresh: false,
    provider,
  })
  await authorizerInstance.initialize()
}

export const resetAuthorizer = (): void => {
  if (authorizerInstance) {
    authorizerInstance.destroy()
  }
  authorizerInstance = null
}

/**
 * Get the Authorizer instance if initialized, or null otherwise
 * Use this for conditional checks where you need TypeScript type narrowing
 */
export const getAuthorizer = (): Authorizer | null => {
  return authorizerInstance
}
